module.exports = __webpack_public_path__ + "static/media/g-icon-upload.7f088462.svg";